import { render, staticRenderFns } from "./ViajesInfoEnturnes.vue?vue&type=template&id=9f90f0fc"
import script from "./ViajesInfoEnturnes.vue?vue&type=script&lang=js"
export * from "./ViajesInfoEnturnes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports